module.exports = __webpack_public_path__ + "files/bd099bf67daa97bfdd2e12296313aa2e.png";